import { EmailTextField } from "@/components/Form/EmailTextField";
import { LS_KEY_EMAIL_LINK_LOGIN_KEY } from "@/config/localStorageKeys";
import { isProduction } from "@/libs/env";
import { auth } from "@/libs/firebase";
import { Box, Button, CircularProgress } from "@mui/material";
import {
	fetchSignInMethodsForEmail,
	sendSignInLinkToEmail,
} from "firebase/auth";
import { useState } from "react";

export function EmailLinkSignInForm({
	onSentEmail,
}: { onSentEmail: () => void }) {
	const [email, setEmail] = useState("");
	const [submitting, setSubmitting] = useState(false);

	const handleSubmitEmailLinkSignin = async (
		e: React.FormEvent<HTMLFormElement>,
	) => {
		e.preventDefault();

		const data = new FormData(e.currentTarget);
		const email = (data.get("email") || "") as string;

		setSubmitting(true);

		const actionCodeSettings = {
			url: `${process.env.NEXT_PUBLIC_APP_URL}/signin-with-email/processing?email=${email}`,
			handleCodeInApp: true,
		};

		try {
			const signInMethods = await fetchSignInMethodsForEmail(auth, email);

			// メールアドレス / パスワードログインをしていないユーザーはエラーを返す
			if (isProduction && !signInMethods.includes("password")) {
				window.alert("このメールアドレスのユーザーは存在しません");
				return;
			}

			await sendSignInLinkToEmail(auth, email, actionCodeSettings).then(() => {
				window.localStorage.setItem(LS_KEY_EMAIL_LINK_LOGIN_KEY, email);
			});
			onSentEmail();
		} catch (e) {
			window.alert("エラーが発生しました！");
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<Box component="form" width="100%" onSubmit={handleSubmitEmailLinkSignin}>
			<EmailTextField
				value={email}
				onChange={(e) => setEmail(e.target.value)}
			/>
			<Button
				type="submit"
				fullWidth
				variant="contained"
				sx={{ mt: 3 }}
				disabled={submitting}
			>
				{submitting ? <CircularProgress color="primary" /> : "次へ"}
			</Button>
		</Box>
	);
}
